import VueGtag, { trackRouter } from 'vue-gtag-next';
import { isDev } from '~~/services/common';

export default defineNuxtPlugin((nuxtApp) => {
    if (isDev()) {
        return;
    }

    // GA4 (G-5DL4LG060W) and Google Ads (AW-10931288777) are NOT configured inside
    // the GTM-NP2LRB7M container (it only holds the X/Twitter pixel), so this plugin
    // is the only thing that sends GA4 data. Removing it (#332) stopped GA4 tracking.

    nuxtApp.vueApp.use(VueGtag, {
        property: [{ id: 'G-5DL4LG060W' }, { id: 'AW-10931288777' }],
    });
    trackRouter(useRouter());
});
